import React, { useEffect, useState } from "react";
import Header from "../components/Header.jsx";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import Services from "../components/Services.jsx";
import Footer from "../components/Footer.jsx";
import axios from "axios";
import AOS from 'aos';
import axiosInstance from "../Auth/axiosInstance";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import SEO from "../components/SEO.jsx";
const ServicePage = () => {
  const [topicData, setTopicData] = useState(null);
  const [sessionData, setsessionData] = useState(null);
  const [ServiceData, setServiceData] = useState(null);
  const [ServiceTwoData, setServiceTwoData] = useState(null);
  const [subscribeData, setsubscribeData] = useState(null);
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [videoData, setVideoData] = useState(null);


  const BASE_URL = process.env.REACT_APP_APP_URL;
  // Define BASE_URL
  const API_URL = `${BASE_URL}/api/v1/topic/187`; // Define API_URL
  const SESSION_API_URL = `${BASE_URL}/api/v1/topic/188`; // Define SESSION_URL
  const SERVICE_API = `${BASE_URL}/api/v1/topic/10`;
  const SERVICE_TWO_API = `${BASE_URL}/api/v1/topic/9`;
  const SUBSCRIBE_API = `${BASE_URL}/api/v1/topic/191`;
  const VIDEO_API = `${BASE_URL}/api/v1/topic/265`;
  useEffect(() => {
    
      // Initialize AOS animations only on the client-side
      AOS.init({
        duration: 1200
      });
    
  }, []); // Properly closing the useEffect for AOS initialization

  // Fetch topic data from API using the dynamic API_URL
  useEffect(() => {
    const fetchApiData = async () => {
      try {
        const response = await axios.get(API_URL);
        const topic = response.data.topic[0];
        setTopicData(topic);
      } catch (err) {
        setError("Error fetching data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchApiData();
  }, [API_URL]);

  // Fetch session data
  useEffect(() => {
    const fetchsessionData = async () => {
      try {
        const response = await axios.get(SESSION_API_URL);
        setsessionData(response.data.topic[0]);

      } catch (err) {
        setError("Error fetching data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchsessionData();
  }, [SESSION_API_URL]);

  // Fetch service data
  useEffect(() => {
    const fetchServiceData = async () => {
      try {
        const response = await axios.get(SERVICE_API);
        setServiceData(response.data.topic[0]);
      } catch (err) {
        setError("Error fetching data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchServiceData();
  }, [SERVICE_API]);

  // Fetch ServiceTwo data
  useEffect(() => {
    const fetchServiceTwoData = async () => {
      try {
        const response = await axios.get(SERVICE_TWO_API);
        setServiceTwoData(response.data.topic[0]);
      } catch (err) {
        setError("Error fetching data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchServiceTwoData();
  }, [SERVICE_TWO_API]);

  // Fetch subscribe data
  useEffect(() => {
    const fetchsubscribeData = async () => {
      try {
        const response = await axios.get(SUBSCRIBE_API);
        setsubscribeData(response.data.topic[0]);
      } catch (err) {
        setError("Error fetching data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchsubscribeData();
  }, [SUBSCRIBE_API]);

  useEffect(() => {
    const fetchVideoData = async () => {
      try {
        const response = await axios.get(VIDEO_API);
        const video = response.data.topic[0];
        setVideoData(video);
      } catch (err) {
        console.error("Error fetching video data:", err);
      }
    };
    fetchVideoData();
  }, [VIDEO_API]);
  
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post(
        `/api/send-discovery-email`,
        { email }
      );
      toast.success(response.data.message);
    } catch (error) {
      toast.error("Failed to send email");
    }
  };

  const title =
    topicData?.fields?.find((field) => field.title === "Component-title")?.value ||
    "Default Title";

  const extractListItems = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const listItems = doc.querySelectorAll("li");
    return Array.from(listItems).map((item) => item.textContent);
  };

  if (loading) {
    return (
      <section className="inner-banner-section skeleton-container">
        <div className="container">
          <div className="row">
            <div data-aos="zoom-in-right" className="col-xl-6 col-lg-6 col-md-12 wow animate__animated animate__zoomIn">
              <div className="banner-caption">
                <div>
                  <h5 className="text-banner-badge hero skeleton"> </h5>
                  <h1 className="main-heading hero mb-0 skeleton"> </h1>
                </div>
                <p className="pera hero skeleton"></p>
                <div className="d-flex gap-3 justify-content-between">
                  <div className="btn-skeleton hero skeleton"></div>
                  <div className="hero-btn-container d-flex gap-1">
                    <span className="play-skeleton hero skeleton"></span>{" "}
                    <p className="skeleton hero btn-skeleton"></p>
                  </div>
                </div>
              </div>
            </div>
            <div data-aos="zoom-in-left" className="col-xl-6 col-lg-6 col-md-12 wow animate__animated animate__zoomIn">
              <div className="banner-img">
                <div className="video hero  skeleton"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) return <p>{error}</p>;

  return (
    <>
    <SEO page="services"  customMeta={{
                   title: "Services - Shape Shifting Mastery",
    description: "Explore our comprehensive range of transformation services. From personalized coaching to group programs.",
    keywords: "transformation services, coaching, fitness programs, personal training, body transformation services",
    ogTitle: "Our Services - Shape Shifting Mastery",
    ogDescription: "Discover our range of transformation services designed to help you achieve your goals."
                }}/>

      {topicData && (
        <section className="inner-banner-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-12 wow animate__animated animate__zoomIn" data-aos="zoom-in-right">
                <div className="banner-caption">
                  <div>
                    <h5 className="text-banner-badge">Services</h5>
                    <h1 className="main-heading mb-0">{title}</h1>
                  </div>
                  <p
                    className="pera"
                    dangerouslySetInnerHTML={{ __html: topicData.details }}
                  ></p>
                  <div className="d-flex gap-3 justify-content-between">
                    <Link to="https://masterhabits.com/" target="_blank" className="btn theme_btn">
                      Take a Quiz Now
                    </Link>
                    <Link to="/podcasts" className="podcast-btn">
                      <div className="waves wave-1"></div>
                      <div className="waves wave-2"></div>
                      <div className="waves wave-3"></div>
                      <span>
                        <i className="fa fa-play"></i>
                      </span>
                      <p className="podcast-text-none">Free Podcast</p>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 wow animate__animated animate__zoomIn" data-aos="zoom-in-left">
                <div className="banner-img">
                  {videoData?.video_file ? (
  <video
    controls
    autoPlay
    loop
    muted
    playsInline
    src={videoData.video_file}
  />
) : (
  <video
                    controls
                    autoPlay
                    loop
                    muted
                    playsInline
                    src="https://www.ssmcanada.com/wp-content/uploads/2024/06/WhatsApp-Video-2024-06-01-at-10.44.50-AM.mp4"
                  />
)}

                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <Services />

      {sessionData && 
      
      (
        <section className="session sec_padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 wow animate__animated animate__slideInLeft" data-aos="fade-right">
                <h1 className="main-heading mb-0">
                  {sessionData.title ||
                    "Health Coaching & Holistic Makeover Coaching 1:1 Session"}
                </h1>
                <p
                  className="pera"
                  dangerouslySetInnerHTML={{
                    __html: sessionData.details?.match(/<p>(.*?)<\/p>/)?.[1] || "Default description text...",
                  }}
                />
                <ul className="list-with-check">
                  {extractListItems(sessionData.details).map((item, index) => (
                    <li key={index}>
                      <i className="fa fa-check"></i>
                      <span className="pera">{item}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/services" className="btn theme_btn">
                  Learn More
                </Link>
              </div>
              <div className="col-lg-6 mt-lg-0 mt-3 mt-sm-4 wow animate__animated animate__slideInRight" data-aos="zoom-in-left">
                <div className="right-img">
                  <img
                    src={sessionData.photo_file}
                    alt={sessionData.title}
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

    </>
  );
};

export default ServicePage;
